import { render, staticRenderFns } from "./notificationPreview.vue?vue&type=template&id=82ae8b3c"
import script from "./notificationPreview.vue?vue&type=script&lang=js"
export * from "./notificationPreview.vue?vue&type=script&lang=js"
import style0 from "./notificationPreview.vue?vue&type=style&index=0&id=82ae8b3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports